import React, {useEffect, useMemo, useRef, useState} from "react";
import styled from "styled-components";
import _ from "lodash";
import {useSelector} from "react-redux";
import {ga4Send} from "../../../function";

// GA4 배너 집계 이벤트명
const GA4_BANNER_VISIBLE = 'add_to_Banner_visible';
const GA4_BANNER_CLICK = 'add_to_Banner_click';

// adState 별 배너 이름. GA4 파라미터(banner_name)로 전송해 배너별로 구분한다.
const BANNER_NAME = {
    // 10: 'squad_clan',
    // 11: 'k_lol_bang',
    // 12: 'uzune_recruit',
    13: 'uzune_clan',
    98: 'deeplol_spot',
    99: 'deeplol_spot2',
};

const sendBannerVisible = (adState) => {
    const bannerName = BANNER_NAME[adState];
    if (!bannerName) {
        return;
    }
    ga4Send(GA4_BANNER_VISIBLE, {banner_name: bannerName});
}

const sendBannerClick = (adState) => {
    const bannerName = BANNER_NAME[adState];
    if (!bannerName) {
        return;
    }
    ga4Send(GA4_BANNER_CLICK, {banner_name: bannerName});
}

const FadeInBox = styled.div`
    max-width: 1080px;
    animation: fadein 1s linear;

    @keyframes fadein {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
`;

// 1 = 롤작귀
// 2 = U4
// 3 = 서라벌 떡방
// 4 = 메디텍고
// 5 = 스쿼드 클랜
// 6 = LRZ  클랜
// 7 = 결망전 광고
// 8 = Faker 광고
// 9 = 롤읽남
// 10 = 스쿼드 클랜
// 11 = K-롤방
// 12 = 우주네 신입모집
// 13 = 우주네 클랜
// 98 = 딥롤 광고1
// 99 = 딥롤 광고2

// 우주네 클랜 배너 노출 종료 (11/10 23:59 까지 노출)
const UZUNE_CLAN_END = new Date(2026, 11 - 1, 10 + 1).getTime();

const Adcalc = (value) => {
    // 우주네 클랜 20% / 딥롤1 40% / 딥롤2 40%
    if (Date.now() < UZUNE_CLAN_END) {
        if (value <= 200) {
            return 13
        } else if (value <= 600) {
            return 98
        }
        return 99
    }

    // 딥롤1 50% / 딥롤2 50%
    if(value <= 500) {
        return 98
    } else {
        return 99
    }

    // 우주네 신입모집 배너 광고 종료
    // if(value <= 500) {
    //     return 12
    // } else if(value <= 750) {
    //     return 98
    // } else {
    //     return 99
    // }

    // 스쿼드 클랜·K-롤방 배너 광고 종료
    // if(value <= 550) {
    //     return 11
    // } else if(value <= 800) {
    //     return 10
    // } else if(value <= 900) {
    //     return 98
    // } else {
    //     return 99
    // }

    // if(value <= 400) {
    //     return 1
    // } else if (value <= 800) {
    //     return 9
    // } else if (value <= 900) {
    //     return 98
    // }
    // return 99

    // if (value <= 300) {
    //     return 6
    // } else if (value <= 600) {
    //     return 5
    // } else if (value <= 800) {
    //     return 98
    // }
    // return 99
};

const randomNumber100 = () => {
    return _.random(1, 1000);
}
const KoreanAd = () => {
    const currentLang = useSelector((state) => state.translation.lang);

    const [adState, setAdState] = useState(() => {
        return Adcalc(randomNumber100())
    });


    const changeState = () => {
        setAdState(prev => {
            let result = prev;
            while (true) {
                if (result !== prev) {
                    break;
                } else {
                    result = Adcalc(randomNumber100());
                }
            }
            return result
        })
    }


    if (currentLang === 'ja') {
        return <JPAd/>
    }

    if (currentLang !== 'KOR') {
        return <OtherAd/>
    }

    // if ([1].includes(adState)) {
    //     return (
    //         <TimeOutBox key={adState + "adState1"} time={10000} changeState={changeState}>
    //             <FadeInBox>
    //                 <a href={'https://open.kakao.com/o/gYQmkHpi'}
    //                    target={'_blank'} id={'add_to_Banner'}>
    //                     <img src={'./images/ad/ad_state1.png'} width={'100%'} height={120} alt={''}
    //                     />
    //                 </a>
    //             </FadeInBox>
    //         </TimeOutBox>
    //     )
    // }
    //
    // if ([2].includes(adState)) {
    //     return (
    //         <TimeOutBox key={adState + "adState2"} time={10000} changeState={changeState}>
    //             <FadeInBox>
    //                 <a href={'https://www.sooplive.co.kr/station/lch9835'}
    //                    target={'_blank'}>
    //                     <img src={'./images/ad/ad_state2.png'} width={'100%'} height={120} alt={''}
    //                     />
    //                 </a>
    //             </FadeInBox>
    //         </TimeOutBox>
    //     )
    // }
    // if ([3].includes(adState)) {
    //     return (
    //         <TimeOutBox key={adState + "adState3"} time={10000} changeState={changeState}>
    //             <FadeInBox>
    //                 <a href={'https://smartstore.naver.com/seorabeol-tteok?nl-ts-pid=jSNiilqostGssOXhXh4-266640&tr=slsmn'}
    //                    target={'_blank'}>
    //                     <img src={'./images/ad/ad_state3.png'} width={'100%'} height={120} alt={''}
    //                     />
    //                 </a>
    //             </FadeInBox>
    //         </TimeOutBox>
    //     )
    // }
    // if ([4].includes(adState)) {
    //     return (
    //         <TimeOutBox key={adState + "adState4"} time={10000} changeState={changeState}>
    //             <FadeInBox>
    //                 <a href={'https://eunpyeong.sen.hs.kr'}
    //                    target={'_blank'}>
    //                     <img src={'./images/ad/ad_state4.png'} width={'100%'} height={120} alt={''}
    //                     />
    //                 </a>
    //             </FadeInBox>
    //         </TimeOutBox>
    //     )
    // }
    // if ([5].includes(adState)) {
    //     return (
    //         <TimeOutBox key={adState + "adState5"} time={10000} changeState={changeState}>
    //             <FadeInBox>
    //                 <a href={'https://www.deeplol.gg/connect/300'}
    //                    target={'_blank'}>
    //                     <img src={'./images/ad/ad_state5.png'} width={'100%'} height={120} alt={''}
    //                     />
    //                 </a>
    //             </FadeInBox>
    //         </TimeOutBox>
    //     )
    // }
    // if ([6].includes(adState)) {
    //     return (
    //         <TimeOutBox key={adState + "adState6"} time={10000} changeState={changeState}>
    //             <FadeInBox>
    //                 <a href={'https://www.deeplol.gg/connect/215'}
    //                    target={'_blank'}>
    //                     <img src={'./images/ad/ad_state6.png'} width={'100%'} height={120} alt={''}
    //                     />
    //                 </a>
    //             </FadeInBox>
    //         </TimeOutBox>
    //     )
    // }
    //
    // if ([7].includes(adState)) {
    //     return (
    //         <TimeOutBox key={adState + "adState7"} time={10000} changeState={changeState}>
    //             <FadeInBox>
    //                 <a href={'https://www.sooplive.co.kr/station/mingyeolhee'}
    //                    target={'_blank'} rel={'noopener'}>
    //                     <img src={'./images/ad/ad_banner_mang.png'} width={'100%'} height={120} alt={''}
    //                     />
    //                 </a>
    //             </FadeInBox>
    //         </TimeOutBox>
    //     )
    // }
    // if ([9].includes(adState)) {
    //     return (
    //         <TimeOutBox key={adState + "adState8"} time={10000} changeState={changeState}>
    //             <FadeInBox>
    //                 <div id={'ad_lol_read_kr'} >
    //                     <img src={'./images/ad/ad_lol_read_kr.png'} width={'100%'} height={120} alt={''}
    //                     />
    //                 </div>
    //             </FadeInBox>
    //         </TimeOutBox>
    //     )
    // }

    // if ([10].includes(adState)) {
    //     return (
    //         <TimeOutBox key={adState + "adState7"} time={10000} changeState={changeState} adState={adState}>
    //             <FadeInBox>
    //                 <a href={'https://www.deeplol.gg/connect/300'}
    //                    target={'_blank'} rel={'noopener'} onClick={() => sendBannerClick(adState)}>
    //                     <img src={'./images/ad/ad_banner_squad.png'} width={'100%'} height={120} alt={''}
    //                     />
    //                 </a>
    //             </FadeInBox>
    //         </TimeOutBox>
    //     )
    // }
    //
    // if ([11].includes(adState)) {
    //     return (
    //         <TimeOutBox key={adState + "adState11"} time={10000} changeState={changeState} adState={adState}>
    //             <FadeInBox>
    //                 <a href={'https://open.kakao.com/o/gGQ80Ucf'}
    //                    target={'_blank'} rel={'noopener'} onClick={() => sendBannerClick(adState)}>
    //                     <img src={'./images/ad/k_lol_banner.png'} width={'100%'} height={120} alt={''}
    //                     />
    //                 </a>
    //             </FadeInBox>
    //         </TimeOutBox>
    //     )
    // }

    // if ([12].includes(adState)) {
    //     return (
    //         <TimeOutBox key={adState + "adState12"} time={10000} changeState={changeState} adState={adState}>
    //             <FadeInBox>
    //                 <a href={'https://open.kakao.com/o/goEalkKi'}
    //                    target={'_blank'} rel={'noopener'} onClick={() => sendBannerClick(adState)}>
    //                     <img src={'./images/ad/uzune_banner.jpg'} width={'100%'} height={120} alt={''}
    //                     />
    //                 </a>
    //             </FadeInBox>
    //         </TimeOutBox>
    //     )
    // }

    if ([13].includes(adState)) {
        return (
            <TimeOutBox time={5000} changeState={changeState} key={adState} adState={adState}>
                <FadeInBox>
                    <a href={'https://open.kakao.com/o/pMTKqLUi'}
                       target={'_blank'} rel={'noopener'} onClick={() => sendBannerClick(adState)}>
                        <img src={'./images/ad/uzune_clan_banner.jpg'} width={'100%'} height={120} alt={''}
                        />
                    </a>
                </FadeInBox>
            </TimeOutBox>
        )
    }

    if ([98].includes(adState)) {
        return (
            <TimeOutBox time={5000} changeState={changeState} key={adState} adState={adState}>
                <FadeInBox>
                    <a href={'https://deeplol.notion.site/3c99262d6d3a80439246da957000d957'}
                       target={'_blank'} onClick={() => sendBannerClick(adState)}>
                        <img src={'./images/ad/ad_deeplol_spot.png'} width={'100%'} height={120} alt={''}
                        />
                    </a>
                </FadeInBox>
            </TimeOutBox>
        )
    }

    if ([99].includes(adState)) {
        return (
            <TimeOutBox time={5000} changeState={changeState} key={adState} adState={adState}>
                <FadeInBox key={adState}>
                    <a href={'https://deeplol.notion.site/3c99262d6d3a80439246da957000d957'}
                       target={'_blank'} onClick={() => sendBannerClick(adState)}>
                        <img src={'./images/ad/ad_deeplol_spot2.png'} width={'100%'} height={120} alt={''}
                        />
                    </a>
                </FadeInBox>
            </TimeOutBox>
        )
    }


    return (
        <TimeOutBox time={5000} changeState={changeState} key={adState} adState={99}>
            <FadeInBox key={adState}>
                <a href={'https://deeplol.notion.site/3c99262d6d3a80439246da957000d957?pvs=4'}
                   target={'_blank'} onClick={() => sendBannerClick(99)}>
                    <img src={'./images/ad/ad_deeplol_spot2.png'} width={'100%'} height={120} alt={''}
                    />
                </a>
            </FadeInBox>
        </TimeOutBox>
    )
}


const TimeBox = () => {
    const time = useMemo(() => {
        const date = new Intl.DateTimeFormat('en', {
            timeZone: 'Asia/Seoul',
            hour12: false,
            hour: '2-digit'
        }).format(new Date());
        return Number(date)
    }, []);

    const href = useMemo(() => {
        if (time > 2 && time < 18) {
            return "https://www.youtube.com/shorts/7XUrRjSMNCg"
        } else {
            return "https://chzzk.naver.com/eb509a24d92170db1ba9bafb58696be0"
        }
    }, [time]);


    return (
        <FadeInBox>
            <a href={href} target={'_blank'}>
                <img src={'./images/ad/ad_state3.png'} width={'100%'} height={120} alt={''}
                />
            </a>
        </FadeInBox>
    )
}

const TimeOutBox = ({time, changeState, children, adState}) => {
    const [isFocused, setIsFocused] = useState(true);
    const timeoutRef = useRef(0);

    const TimeoutBoxSetTimeout = () => {
        return setTimeout(() => {
            changeState();
        }, time)
    }

    // 배너가 화면에 렌더될 때마다 노출 1회 집계
    useEffect(() => {
        sendBannerVisible(adState);
    }, [adState])

    useEffect(() => {
        if (isFocused) {
            timeoutRef.current = TimeoutBoxSetTimeout();
        } else if (!isFocused && timeoutRef.current) {
            clearTimeout(timeoutRef.current)
        }
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current)
            }
        }
    }, [isFocused])


    useEffect(() => {
        const handleFocusChange = () => {
            setIsFocused(document.hasFocus());
        };

        window.addEventListener("focus", handleFocusChange);
        window.addEventListener("blur", handleFocusChange);

        // 컴포넌트 언마운트 시 이벤트 제거
        return () => {
            window.removeEventListener("focus", handleFocusChange);
            window.removeEventListener("blur", handleFocusChange);
        };
    }, []);


    return children
}

// 총 9개
const OtherAdCalc = (value) => {
    // if(value <= 500) {
    //     return 7
    // } else if (value <= 570) {
    //     return 1
    // } else if (value <= 640) {
    //     return 2
    // } else if (value <= 710) {
    //     return 3
    // } else if (value <= 780) {
    //     return 4
    // } else if (value <= 850) {
    //     return 5
    // }
    // if (value <= 200) {
    //     return 2
    // }
    return 1
}

const OtherAd = () => {
    return null
    // const [adState, setAdState] = useState(() => {
    //     return OtherAdCalc(randomNumber100())
    // });
    //
    //
    // const changeState = () => {
    //     setAdState(prev => {
    //         let result = prev;
    //         while (true) {
    //             if (result !== prev) {
    //                 break;
    //             } else {
    //                 result = OtherAdCalc(randomNumber100());
    //             }
    //         }
    //         return result
    //     })
    //
    // }
    // if ([1].includes(adState)) {
    //     return (
    //         <TimeOutBox key={adState + "adState1en"} time={10000} changeState={changeState}>
    //             <FadeInBox>
    //                 <a href={'https://www.mobatrainer.com/puzzle-of-the-day?utm_source=website&utm_medium=banner&utm_campaign=DEEP20_Hardstuck'}
    //                    target={'_blank'} rel={'noopener'} id={'add_to_Banner_2'}>
    //                     <img src={'./images/ad/mobatrainer/final2.png'} width={'100%'} height={120} alt={''}
    //                     />
    //                 </a>
    //             </FadeInBox>
    //         </TimeOutBox>
    //     )
    // }
    //
    //
    // if ([2].includes(adState)) {
    //     return (
    //         <TimeOutBox key={adState + "adState1en"} time={10000} changeState={changeState}>
    //             <FadeInBox>
    //                 <div rel={'noopener'} id={'ad_lol_read_en'}>
    //                     <img src={'./images/ad/ad_lol_read_en.png'} width={'100%'} height={120} alt={''}
    //                     />
    //                 </div>
    //             </FadeInBox>
    //         </TimeOutBox>
    //     )
    // }


    // if ([10].includes(adState)) {
    //     return (
    //         <TimeOutBox key={adState + "adState10en"} time={10000} changeState={changeState}>
    //             <FadeInBox>
    //                 <a href={'https://www.youtube.com/@feviknight'}
    //                    target={'_blank'}>
    //                     <img src={'./images/ad/fevi/1118_Opt01_ENG.png'} width={'100%'} height={120} alt={''}
    //                     />
    //                 </a>
    //             </FadeInBox>
    //         </TimeOutBox>
    //     )
    // }
    // if ([11].includes(adState)) {
    //     return (
    //         <TimeOutBox key={adState + "adState11en"} time={10000} changeState={changeState}>
    //             <FadeInBox>
    //                 <a href={'https://www.youtube.com/@feviknight'}
    //                    target={'_blank'}>
    //                     <img src={'./images/ad/fevi/1118_Opt02_ENG.png'} width={'100%'} height={120} alt={''}
    //                     />
    //                 </a>
    //             </FadeInBox>
    //         </TimeOutBox>
    //     )
    // }
    //
    //
    // return <TimeOutBox key={adState + "adState9en"} time={10000} changeState={changeState}>
    //     <FadeInBox>
    //         <a href={'https://www.mobatrainer.com/puzzle-of-the-day?utm_source=website&utm_medium=banner&utm_campaign=DEEP20_Hardstuck'}
    //            target={'_blank'} rel={'noopener'} id={'add_to_Banner_2'}>
    //             <img src={'./images/ad/mobatrainer/final2.png'} width={'100%'} height={120} alt={''}
    //             />
    //         </a>
    //     </FadeInBox>
    // </TimeOutBox>
}


const JpAdCalc = (value) => {
    // if(value <= 500) {
    //     return 7
    // } else if (value <= 570) {
    //     return 1
    // } else if (value <= 640) {
    //     return 2
    // } else if (value <= 710) {
    //     return 3
    // } else if (value <= 780) {
    //     return 4
    // } else if (value <= 850) {
    //     return 5
    // }
    if (value <= 200) {
        return 2
    }
    return 1
}

const JPAd = () => {
    const [adState, setAdState] = useState(() => {
        return JpAdCalc(randomNumber100())
    });


    const changeState = () => {
        setAdState(prev => {
            let result = prev;
            while (true) {
                if (result !== prev) {
                    break;
                } else {
                    result = JpAdCalc(randomNumber100());
                }
            }
            return result
        })

    }
    if ([1].includes(adState)) {
        return (
            <TimeOutBox key={adState + "adState1jp"} time={10000} changeState={changeState}>
                <FadeInBox>
                    <a href={'https://www.mobatrainer.com/puzzle-of-the-day?utm_source=website&utm_medium=banner&utm_campaign=DEEP20_Hardstuck_JP'}
                       target={'_blank'} rel={'noopener'} id={'add_to_Banner_5'}>
                        <img src={'./images/ad/mobatrainer/final2_jp.png'} width={'100%'} height={120} alt={''}
                        />
                    </a>
                </FadeInBox>
            </TimeOutBox>
        )
    }

    if ([2].includes(adState)) {
        return (
            <TimeOutBox key={adState + "adState2jp"} time={10000} changeState={changeState}>
                <FadeInBox>
                    <div rel={'noopener'} id={'ad_lol_read_jp'}>
                        <img src={'./images/ad/ad_lol_read_jp.png'} width={'100%'} height={120} alt={''}
                        />
                    </div>
                </FadeInBox>
            </TimeOutBox>
        )
    }

    return <TimeOutBox key={adState + "adState9jp"} time={10000} changeState={changeState}>
        <FadeInBox>
            <a href={'https://www.mobatrainer.com/puzzle-of-the-day?utm_source=website&utm_medium=banner&utm_campaign=DEEP20_Hardstuck_JP'}
               target={'_blank'} rel={'noopener'} id={'add_to_Banner_5'}>
                <img src={'./images/ad/mobatrainer/final2_jp.png'} width={'100%'} height={120} alt={''}
                />
            </a>
        </FadeInBox>
    </TimeOutBox>
}


export default React.memo(KoreanAd)